import React from "react";
import { HeroCarouselComponentDisplay } from "cms/components/components/hero-carousel/display/index";
import { HeroCarouselComponentEditor } from "cms/components/components/hero-carousel/edit/index";
import { getComponentZoneLayout } from "cms/components/components/component";

const HeroCarouselComponent = (props) => {
    
    const { ...everything } = props;
    const zoneProps = {
        ...everything,
        displayComponent: <HeroCarouselComponentDisplay />,
        editComponent: <HeroCarouselComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

HeroCarouselComponent.displayName = "HeroCarouselComponent";
export { HeroCarouselComponent };
